module.exports = [{
      plugin: require('/Users/greyson/Site/gatsby-portfolio-via-gap/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-107072121-1"},
    }]
